import { Modal } from 'antd';
import { T } from 'react-translator-component';

/**
 * Shows a confirmation modal before marking a user as trusted.
 * Only used when enabling the "Trusted user" option; disabling is immediate.
 *
 * @param {() => void} onConfirm - called when the user confirms the action.
 */
export const confirmTrustedUser = (onConfirm) =>
  Modal.confirm({
    title: T('Mark as trusted user'),
    content: T(
      'By marking this user as trusted, you will be assuming the risks of possible fraud associated with this account.',
    ),
    okText: T('Yes'),
    cancelText: T('No'),
    centered: true,
    onOk: onConfirm,
  });
